import { Decimal } from 'decimal.js'

export function minusTwoNumbers (a, b) {
    return new Decimal(a).minus(b).toNumber()
}
